const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/zgks/eCheckin/sections/PersAngaben.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import { CIS4mTextField } from '@cistec/common_web/modules/CIS4m/components/CIS4mTextField';
import textMapCommon from '../../../common/translations';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { EMailField } from 'App/components/eCheckin/components/fields/EMailField';
import { AddressBlock, AddressFieldsConfig } from 'App/components/eCheckin/components/fields/AddressBlock';
import { PhoneNumberField } from 'App/components/eCheckin/components/fields/PhoneNumberField';
import textMap from '../translations';
import { atLeastOneHasValue } from '@cistec/common_web/modules/CIS4m/utils/data';
import { BirthDateField } from 'App/components/eCheckin/components/fields/BirthDateField';
import { GenderField } from 'App/components/eCheckin/components/fields/metakat/GenderField';
import { ZivilstandField } from 'App/components/eCheckin/components/fields/metakat/ZivilstandField';
import { CountryField } from 'App/components/eCheckin/components/fields/metakat/CountryField';
import { AHVField } from 'App/components/eCheckin/components/fields/AHVField';
import { ReligionField } from 'App/components/eCheckin/components/fields/metakat/ReligionField';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { createFieldPath } from 'App/components/eCheckin/utils';
import { validateAHVNoDots } from '@cistec/common_web/components/Forms/utils/validation';

const addressFieldsConfig: AddressFieldsConfig = {
    additionalInfo: {
        included: false,
    },
};

export const PersAngaben = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_FIRST_NAME = createFieldPath(path, 'firstname');
    const PATH_LAST_NAME = createFieldPath(path, 'lastname');
    const PATH_EMAIL = createFieldPath(path, 'email');
    const PATH_COUNTRY = createFieldPath(path, 'country');
    const PATH_TEL = createFieldPath(path, 'tel');
    const PATH_TEL_MOBILE = createFieldPath(path, 'mobile');
    const PATH_BIRTH_DATE = createFieldPath(path, 'dateOfBirth');
    const PATH_GENDER = createFieldPath(path, 'geschlecht');
    const PATH_ZIVILSTAND = createFieldPath(path, 'zivilstand');
    const PATH_NATIONALITY = createFieldPath(path, 'nationality');
    const PATH_PROFESSION = createFieldPath(path, 'profession');
    const PATH_AHV = createFieldPath(path, 'ahv');
    const PATH_RELIGION = createFieldPath(path, 'religion');
    const PATH_HOME_TOWN = createFieldPath(path, 'hometown');

    const formData = useCIS4mData();
    const phoneNumberRequired = !atLeastOneHasValue(formData, [PATH_TEL, PATH_TEL_MOBILE]);

    const eCheckinSectionRef = useCIS4m(ref);
    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <CIS4mTextField label={textMapCommon.firstname} path={PATH_FIRST_NAME} required={true} />
            <CIS4mTextField label={textMapCommon.lastname} path={PATH_LAST_NAME} required={true} />
            <EMailField label={textMapCommon.email} path={PATH_EMAIL} required={true} />
            <AddressBlock basePath={path} required={true} fieldsConfig={addressFieldsConfig} />
            <PhoneNumberField label={textMap.telLandline} path={PATH_TEL} countryCodePath={PATH_COUNTRY} />
            <PhoneNumberField label={textMapCommon.mobile} path={PATH_TEL_MOBILE} countryCodePath={PATH_COUNTRY} />
            <BirthDateField label={textMap.dateOfBirth} path={PATH_BIRTH_DATE} required={true} />
            <GenderField label={textMap.gender} path={PATH_GENDER} required={true} />
            <ZivilstandField label={textMap.zivilstand} path={PATH_ZIVILSTAND} required={true} />
            <CountryField label={textMap.nationality} path={PATH_NATIONALITY} required={true} />
            <CIS4mTextField label={textMap.profession} path={PATH_PROFESSION} />
            <AHVField
                label={textMap.ahv}
                path={PATH_AHV}
                required={true}
                mask={'7569999999999'}
                helperText={textMap.ahvHelpText}
                checkValidity={validateAHVNoDots}
            />
            <ReligionField label={textMap.religion} path={PATH_RELIGION} />
            <CIS4mTextField label={textMap.hometown} path={PATH_HOME_TOWN} />
        </ECheckinSection>
    );
});

PersAngaben.displayName = 'PersAngaben';

export default PersAngaben;
